<recon-dashboard
  [source]="source"
  [account]="account"
  [reconDate]="reconDate"
  [panelKey]="panelKey"
  [userPolicy]="userPolicy"
  [initialized]="initialized"
  [getUserDashboardConfig]="getUserDashboardConfig"
  [putUserDashboardConfig]="putUserDashboardConfig"
></recon-dashboard>
